import { render } from "./ContentTextImageBox.vue?vue&type=template&id=1bc5a287"
import script from "./ContentTextImageBox.vue?vue&type=script&lang=js"
export * from "./ContentTextImageBox.vue?vue&type=script&lang=js"

import "./ContentTextImageBox.vue?vue&type=style&index=0&id=1bc5a287&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__